<template>
    <page-header-wrapper>
        <a-card :bordered="false">
            <!-- 条件搜索 -->
            <div class="table-page-search-wrapper">
                <a-form layout="inline">
                    <a-row :gutter="48">
                        <a-col :md="8" :sm="24">
                            <a-form-item label="分享类型" prop="type">
                                <a-select v-model="queryParam.type" placeholder="请选择" allow-clear>
                                    <a-select-option value="1">剧集分享</a-select-option>
                                    <a-select-option value="2">邀请好友</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <!-- <a-col :md="8" :sm="24">
                            <a-form-item label="分享类型" prop="channel">
                                <a-select v-model="queryParam.channel" placeholder="请选择" allow-clear>
                                    <a-select-option value="1">facebook</a-select-option>
                                    <a-select-option value="2">twitter</a-select-option>
                                    <a-select-option value="3">whatsapp</a-select-option>
                                    <a-select-option value="4">other</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col> -->
                        <a-col :md="!advanced && 8 || 24" :sm="24">
                            <span class="table-page-search-submitButtons"
                                :style="advanced && { float: 'right', overflow: 'hidden' } || {}">
                                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
            <!-- 操作 -->
            <div class="table-operations">
                <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['video:push:add']">
                    <a-icon type="plus" />新增
                </a-button>
                <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['video:push:remove']">
                    <a-icon type="delete" />删除
                </a-button>
                <table-setting :style="{ float: 'right' }" :table-size.sync="tableSize" v-model="columns"
                    :refresh-loading="loading" @refresh="getList" />
            </div>
            <!-- 增加修改 -->
            <create-form ref="createForm" @ok="getList" />
            <!-- 数据展示 -->
            <a-table :loading="loading" :size="tableSize" rowKey="id" :columns="columns" :data-source="list"
                :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :pagination="false"
                :bordered="tableBordered">
                <img slot="coverUrl" slot-scope="text, record" style="width: 48px;height: 48px;" :preview="record.coverUrl"
                    v-image-preview :src="record.coverUrl">
                    <img slot="coverUrlEn" slot-scope="text, record" style="width: 48px;height: 48px;" :preview="record.coverUrlEn"
                    v-image-preview :src="record.coverUrlEn">
                    <img slot="coverUrlJa" slot-scope="text, record" style="width: 48px;height: 48px;" :preview="record.coverUrlJa"
                    v-image-preview :src="record.coverUrlJa">
                <span slot="isOpen" slot-scope="text, record">
                    <a-switch checkedChildren="是" unCheckedChildren="否" v-model="record.isOpen == 1"
                        @change="changeIsOpen($event, record)" />
                </span>
                <span slot="operation" slot-scope="text, record">
                    <a-divider type="vertical" v-hasPermi="['video:push:edit']" />
                    <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['video:push:edit']">
                        <a-icon type="edit" />修改
                    </a>
                    <a-divider type="vertical" v-hasPermi="['video:push:remove']" />
                    <a @click="handleDelete(record)" v-hasPermi="['video:push:remove']">
                        <a-icon type="delete" />删除
                    </a>
                </span>
            </a-table>
            <!-- 分页 -->
            <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper :current="queryParam.pageNum"
                :total="total" :page-size="queryParam.pageSize" :showTotal="total => `共 ${total} 条`"
                @showSizeChange="onShowSizeChange" @change="changeSize" />
        </a-card>
    </page-header-wrapper>
</template>
  
<script>
import { pageShare, delShare, changeIsOpen } from '@/api/video/shareMaterial'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
    name: 'Share',
    components: {
        CreateForm
    },
    mixins: [tableMixin],
    data() {
        return {
            list: [],
            selectedRowKeys: [],
            selectedRows: [],
            // 高级搜索 展开/关闭
            advanced: false,
            // 非单个禁用
            single: true,
            // 非多个禁用
            multiple: true,
            ids: [],
            loading: false,
            total: 0,
            // 查询参数
            queryParam: {
                type: null,
                channel: null,
                pageNum: 1,
                pageSize: 10
            },
            columns: [
                {
                    title: '中文内容',
                    dataIndex: 'content',
                    ellipsis: true,
                    align: 'center'
                },
                {
                    title: '英文内容',
                    dataIndex: 'contentEn',
                    ellipsis: true,
                    align: 'center'
                },
                {
                    title: '日语内容',
                    dataIndex: 'contentJa',
                    ellipsis: true,
                    align: 'center'
                },
                {
                    title: '类型',
                    dataIndex: 'type',
                    ellipsis: true,
                    align: 'center',
                    customRender: function (type) {
                        if (type == 1) {
                            return '分享剧集'
                        } else if (type == 2) {
                            return '邀请好友'
                        }
                    }
                },
                // {
                //     title: '类型',
                //     dataIndex: 'channel',
                //     ellipsis: true,
                //     align: 'center',
                //     customRender: function (channel) {
                //         if (channel == 1) {
                //             return 'facebook'
                //         } else if (channel == 2) {
                //             return 'twitter'
                //         } else if (channel == 3) {
                //             return 'whatsapp'
                //         } else if (channel == 4) {
                //             return 'other'
                //         }
                //     }
                // },
                {
                    title: '封面图',
                    dataIndex: 'coverUrl',
                    align: 'center',
                    width: '180',
                    scopedSlots: { customRender: 'coverUrl' }
                },
                {
                    title: '英文封面图',
                    dataIndex: 'coverUrlEn',
                    align: 'center',
                    width: '180',
                    scopedSlots: { customRender: 'coverUrlEn' }
                },
                {
                    title: '日语封面图',
                    dataIndex: 'coverUrlJa',
                    align: 'center',
                    width: '180',
                    scopedSlots: { customRender: 'coverUrlJa' }
                },
                {
                    title: '是否启用',
                    dataIndex: 'isOpen',
                    align: 'center',
                    scopedSlots: { customRender: 'isOpen' }
                },
                {
                    title: '创建时间',
                    dataIndex: 'createTime',
                    scopedSlots: { customRender: 'createTime' },
                    ellipsis: true,
                    align: 'center'
                },
                {
                    title: '操作',
                    dataIndex: 'operation',
                    width: '18%',
                    scopedSlots: { customRender: 'operation' },
                    align: 'center'
                }
            ]
        }
    },
    filters: {
    },
    created() {
        this.getList()
    },
    computed: {
    },
    watch: {
    },
    methods: {
        changeIsOpen(e, record) {
            record.isOpen = e ? 1 : 0
            changeIsOpen({ id: record.id, isOpen: record.isOpen }).then(response => {
                this.$message.success(
                    '操作成功'
                )
                return record.isOpen = e ? 1 : 0
            })
        },
        getList() {
            this.loading = true
            pageShare(this.queryParam).then(response => {
                this.list = response.data.records
                this.total = response.data.total
                this.loading = false
            })
        },

        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParam.pageNum = 1
            this.getList()
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParam = {
                type: undefined,
                language: undefined,
                pageNum: 1,
                pageSize: 10
            }
            this.handleQuery()
        },
        onShowSizeChange(current, pageSize) {
            this.queryParam.pageSize = pageSize
            this.getList()
        },
        changeSize(current, pageSize) {
            this.queryParam.pageNum = current
            this.queryParam.pageSize = pageSize
            this.getList()
        },
        onSelectChange(selectedRowKeys, selectedRows) {
            this.selectedRowKeys = selectedRowKeys
            this.selectedRows = selectedRows
            this.ids = this.selectedRows.map(item => item.id)
            this.single = selectedRowKeys.length !== 1
            this.multiple = !selectedRowKeys.length
        },
        toggleAdvanced() {
            this.advanced = !this.advanced
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            var that = this
            const ids = row.id || this.ids
            if (row.id) {
                this.ids.push(row.id)
            }
            this.$confirm({
                title: '确认删除所选中数据?',
                content: '当前选中编号为' + ids + '的数据',
                onOk() {
                    const data = []
                    that.ids.map(id => data.push({ 'id': id }))
                    return delShare(data)
                        .then(() => {
                            that.onSelectChange([], [])
                            that.getList()
                            that.$message.success(
                                '删除成功',
                                3
                            )
                        })
                },
                onCancel() {
                    // 取消清空删除ids列表
                    that.ids = []
                }
            })
        },
    }
}
</script>
  